import { ThemeProvider, ToastContainer } from '@stardust-ds/react';
import { HashRouter } from 'react-router-dom';
import Routes from 'routes';
import Global, { theme } from './styles/global';
import MaintenancePage from 'pages/Maintenance';

const isMaintenanceMode = process.env.REACT_APP_IS_UNDER_MAINTENANCE === 'true';

function App() {
    if (isMaintenanceMode)
        return (
            <ThemeProvider theme={theme}>
                <Global />
                <MaintenancePage />
            </ThemeProvider>
        );

    return (
        <ThemeProvider theme={theme}>
            <Global />
            <main className="container">
                <HashRouter>
                    <Routes />
                </HashRouter>
            </main>
            <ToastContainer />
        </ThemeProvider>
    );
}

export default App;
